import { post } from "../../config/api-config/callMethods";
import { environment } from "../../config/environments/environment";

/**
 * To add single/multiple new user
 */
export function matrixUserLogout(token: any) {
    const url = environment.matrixConvaychatLogoutUrl;
    const headers = {
        'Authorization': `Bearer ${token}`
    };
    return post(url, null, { headers: headers });
}